import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { ToastService } from 'src/app/services/toast.service';
import { AuthenticationService } from '../../services/authentication.service';
import { DuelService } from '../../services/duel.service';

export interface Duel {}
@Component({
	selector: 'app-challenge-improve',
	templateUrl: './challenge-improve.component.html',
	styleUrls: ['./challenge-improve.component.scss'],
})
export class ChallengeImproveComponent implements OnInit {
	@Input() secret_id: string = '';
	@Input() amount: number = 0;
	@Input() id: string = '';
	rForm!: UntypedFormGroup;
	duel!: Duel;
	smallerAmount: boolean = false;

	constructor(
		private duelService: DuelService,
		public modalController: ModalController,
		private router: Router,
		private authenticationService: AuthenticationService,
		private toastService: ToastService,
	) {}

	ngOnInit() {
		// history.pushState('', null); // TODO: no clue what that does
		this.duelService.getDuelById(this.id).subscribe(res => {
			this.duel = res.duel;
		});
		this.initForm();
	}

	initForm() {
		this.rForm = new UntypedFormGroup({
			amount: new UntypedFormControl(null, {
				validators: [Validators.min(5)],
			}),
		});

		// check if amount > old amount
		this.rForm.get('amount')?.valueChanges.subscribe(value => {
			if (value <= this.amount) {
				this.smallerAmount = true;
			} else {
				this.smallerAmount = false;
			}
		});

		const increasedAmount = this.amount * 2;
		this.rForm.get('amount')?.setValue(increasedAmount);
	}

	closeModal() {
		this.modalController.dismiss({
			dismissed: true,
		});
	}

	submitForm() {
		if (this.rForm.invalid) {
			return;
		}

		this.duelService
			.challengeImprove({
				secret_id: this.secret_id,
				amount: this.rForm.value.amount,
			})
			.subscribe(() => {
				this.closeModal();
				this.toastService.showToastOnSuccess('Herausforderung erhöht!');
				this.router.navigate(['/app/duel-list/']);
			});
	}
}
